var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { useQuery } from "react-query";
import { featureFlagsApiRequest } from "./feature-flags-client";
import { getAccessToken, getAuthenticatedUser } from "../auth-api-client";
var FeatureFlag = /* @__PURE__ */ ((FeatureFlag2) => {
  FeatureFlag2["BetaFeatures"] = "student.beta-features";
  FeatureFlag2["DuplicateTabPage"] = "student.duplicate-tab-page";
  FeatureFlag2["ReaderSubmitCall"] = "student.reader-submit-call";
  FeatureFlag2["SpanishTranslation"] = "student.spanish-translation";
  FeatureFlag2["DuplicateTabPageContinueButton"] = "student.duplicate-tab-page-continue-button";
  FeatureFlag2["AddCourse"] = "student.add-course";
  FeatureFlag2["Announcements"] = "student.announcements";
  FeatureFlag2["Messages"] = "student.messages";
  FeatureFlag2["ENotes"] = "student.enotes";
  FeatureFlag2["ProgressOverview"] = "student.progress-overview";
  FeatureFlag2["PlagiarismVideo"] = "student.plagiarism-video";
  FeatureFlag2["GuidedNotes"] = "student.guided-notes";
  FeatureFlag2["LessonDetails"] = "student.lesson-details";
  FeatureFlag2["GoPeer"] = "student.go-peer";
  FeatureFlag2["PlayerVersion"] = "player.version";
  FeatureFlag2["Proctorio"] = "proctorio";
  return FeatureFlag2;
})(FeatureFlag || {});
const CACHE_TIME_MILLIS = 36e5;
const getFeatureFlagEvaluationEntities = () => {
  const user = getAuthenticatedUser();
  if (!user) {
    return [];
  }
  return [
    {
      entityType: "user",
      entityID: user.userid,
      entityContext: {
        userId: user.userid,
        userName: user.username,
        role: user.role,
        districtId: user.districtId,
        schoolId: user.school_id
      }
    }
  ];
};
function useFeatureFlag(flagKey, defaultValue, entities) {
  var _a;
  entities = entities || getFeatureFlagEvaluationEntities();
  if (!entities) {
    return { value: defaultValue, isLoading: false };
  }
  const flagKeys = Object.values(FeatureFlag);
  const token = getAccessToken();
  try {
    const { data, isLoading, isSuccess } = useFlagEvaluationBatchQuery(
      entities,
      flagKeys,
      { enabled: Boolean(token) }
    );
    if (isLoading) {
      return { isLoading: true };
    }
    if (isSuccess && data) {
      const evaluationResult = (_a = data.evaluationResults) == null ? void 0 : _a.find(
        (evalResult) => (evalResult == null ? void 0 : evalResult.flagKey) === flagKey
      );
      const value = (evaluationResult == null ? void 0 : evaluationResult.variantKey) ? evaluationResult.variantKey === "true" : defaultValue;
      return {
        value,
        isLoading: false,
        attachment: evaluationResult == null ? void 0 : evaluationResult.variantAttachment
      };
    }
  } catch (err) {
    console.error(err);
  }
  return { value: defaultValue, isLoading: false };
}
function useFlagEvaluationBatchQuery(entityContexts, flagKeys, options) {
  return useQuery(
    ["evaluateFeatureFlags", entityContexts],
    () => {
      return featureFlagsApiRequest({
        url: "/feature-flags",
        method: "post",
        data: { entities: entityContexts, flagKeys }
      });
    },
    __spreadProps(__spreadValues({}, options), {
      cacheTime: CACHE_TIME_MILLIS,
      staleTime: CACHE_TIME_MILLIS,
      useErrorBoundary: false
    })
  );
}
export {
  FeatureFlag,
  useFeatureFlag
};
